package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_03_31_Day_1
import com.veldekar.components.logs.Log_2023_03_31_Day_2
import com.veldekar.components.logs.Log_2023_03_31_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-03-31")
@Composable
public fun Log_2023_03_31(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Trouble in Blave",
        ogTitle = "Trouble in Blave",
        date = LocalDate(2_023, 3, 31),
        ogDescription = "Arriving in Blave, the heroes learn of Hill Giants and Ettins harassing the region's military outposts.",
        ogImage = "ai/2023-03-31.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-21", dateString = "Newgrowth 21")
        Log_2023_03_31_Day_1()
        SessionDayHeader(dayId = "newgrowth-22", dateString = "Newgrowth 22")
        Log_2023_03_31_Day_2()
        SessionDayHeader(dayId = "newgrowth-23", dateString = "Newgrowth 23")
        Log_2023_03_31_Day_3()
    }
}
